import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";
import * as _ from "lodash";
import * as moment from "moment";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { DatePipe } from "@angular/common";
import { Guid } from "guid-typescript";

import { AdmissionsService, UserService, MediaWatcherService } from "../../_services";
import { AdmissionsApplicationDocumentUploadDialogComponent } from "./applicationDocumentUpload";

@Component({
    templateUrl: "admissionsApplicationDocumentsDialog.component.html",
    styleUrls: ["admissionsApplicationDocumentsDialog.component.css"],
    providers: [DatePipe]
})
export class AdmissionsApplicationDocumentsDialogComponent implements OnInit, OnDestroy {
    applicationId = 0;
    scholasticPeriod: string;
    funnelId: number;
    funnel: string;
    changesDetected = false;
    isMobile = false;
    mediaWatcherSubscription: Subscription;

    documentDetails = new BehaviorSubject<any[]>([]);
    documentDetails$: Observable<any> = this.documentDetails.asObservable();

    displayedColumns = ["fileExtension", "studentDocumentTypeDescription", "studentDocumentStatusId", "fileName", "dateCreated", "lastUpdatedOn", "edit", "view"];

    essayFileName: string = null;
    essayFileType: string = null;
    essayAttachmentId: number = null;

    constructor(private dialogRef: MatDialogRef<AdmissionsApplicationDocumentsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        public dialog: MatDialog,
        private admissionsService: AdmissionsService,
        private userService: UserService,
        private mediaWatcherService: MediaWatcherService) {
        this.applicationId = data.applicationId;
        this.scholasticPeriod = data.scholasticPeriod;
        this.funnelId = data.funnelId;
        this.funnel = data.funnel;
    }

    ngOnDestroy() {
        this.documentDetails.unsubscribe();
        this.mediaWatcherSubscription.unsubscribe();
    }

    ngOnInit() {
        //this.googleAnalyticsService.logPageView("/admissionsChecklistItems");

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;

            if (this.isMobile)
                this.displayedColumns = ["studentDocumentTypeDescription", "description", "studentDocumentStatusId", "fileName", "dateCreated", "lastUpdatedOn", "edit", "view"];
            else
                this.displayedColumns = ["fileExtension", "studentDocumentTypeDescription", "studentDocumentStatusId", "fileName", "dateCreated", "lastUpdatedOn", "edit", "view"];
        });

        this.getApplicationDocuments();
    }

    getApplicationDocuments() {
        this.admissionsService.getAdmissionsApplicationDocuments(this.applicationId, this.funnelId)
            .pipe(first())
            .subscribe((result: any) => {
                if (result) {
                    var documentDetails = [];

                    _.forEach(result, (f: any) => {
                        const documentData = {
                            id: f.id,
                            attachmentId: f.attachmentId,
                            fileExtension: f.fileExtension,
                            fileName: f.fileName,
                            description: f.description,
                            studentDocumentTypeId: f.studentDocumentTypeId,
                            studentDocumentTypeDescription: f.studentDocumentTypeDescription,
                            dateCreated: f.dateCreated ? moment(f.dateCreated).format("YYYY-MM-DD") : null,
                            lastUpdatedOn: f.lastUpdatedOn ? moment(f.lastUpdatedOn).format("YYYY-MM-DD"): null,
                            studentDocumentStatusId: f.studentDocumentStatusId,
                            studentDocumentStatusDescription: f.studentDocumentStatusDescription,
                            isVisibleToStudent: f.isVisibleToStudent,
                            allowedUploadDocumentTypes: f.allowedUploadDocumentTypes,
                            allowMultipleOfType: f.allowMultipleOfType,
                            rejectedReason: f.rejectedReason,
                            uploadedByStudent: f.uploadedByStudent,
                            sortOrder: f.studentDocumentStatusId === 5 ? 1 : f.studentDocumentStatusId === 1 ? 4 : f.studentDocumentStatusId === 4 ? 2 : f.studentDocumentStatusId === 2 ? 5 : f.studentDocumentStatusId === 6 ? 3 : 6,
                            rowversion: f.rowversion,
                            attachmentRowversion: f.attachmentRowversion,
                            guid: Guid.create()
                        };

                        documentDetails.push(documentData);
                    });

                    this.documentDetails.next(_.orderBy(documentDetails, ["sortOrder", "studentDocumentTypeDescription"], ["asc", "asc"]));
                }
            });
    }

    close() {
        this.dialogRef.close(this.changesDetected);
    }

    openDocument(attachmentId: number, fileType: string) {
        this.userService.openAttachment(attachmentId)
            .pipe(first())
            .subscribe((response: any) => {
                const file = new Blob([response], { type: fileType });
                var fileUrl = URL.createObjectURL(file);
                window.open(fileUrl);
            });
    }

    modifyApplicationDocuments(guid: any) {
        const document = this.documentDetails.value.find(f => f.guid === guid);

        if (document && document.isVisibleToStudent && document.studentDocumentStatusId !== 3 && document.studentDocumentStatusId !== 2) {
            const dialogConfig = new MatDialogConfig();

            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.closeOnNavigation = true;
            dialogConfig.width = this.isMobile ? "75%" : "70%";
            dialogConfig.maxWidth = "70vw";
            dialogConfig.height = "auto";
            dialogConfig.panelClass = "popup-dialog-container";

            dialogConfig.data = {
                id: document.id,
                applicationId: this.applicationId,
                attachmentId: document.attachmentId,
                studentDocumentTypeId: document.studentDocumentTypeId,
                studentDocumentType: document.studentDocumentTypeDescription,
                allowedUploadDocumentTypes: document.allowedUploadDocumentTypes,
                rowversion: document.rowversion,
                attachmentRowversion: document.attachmentRowversion,
                description: document.description,
                fileName: document.fileName,
                allowMultipleOfType: document.allowMultipleOfType
            };

            const dialogRef = this.dialog.open(AdmissionsApplicationDocumentUploadDialogComponent, dialogConfig);

            dialogRef.afterClosed().subscribe(val => {
                if (val) {
                    setTimeout(() => {
                        this.changesDetected = true;
                        this.getApplicationDocuments();
                    }, 500);
                }
            });
        }
    }

}